import { makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { MDSTag, MDSTypography } from '@marqvision/mds-v2';
import { ListItem } from './@components/ListItem';
import { useViewModel } from './@hooks/useViewModel';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '4px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  section: {
    padding: '12px 20px',
    display: 'grid',
    gap: '12px',
  },
  empty: {
    height: '100%',
    display: 'grid',
    placeItems: 'center',
  },
}));

type Props = {
  onClick: (id: number) => void;
};

export const List = (props: Props) => {
  const { onClick } = props;
  const classes = useStyles();

  const { isLoading, isEmpty, list, listItemProps } = useViewModel();

  if (isEmpty)
    return (
      <div className={classes.empty}>
        <MDSTypography color="color/content/placeholder/normal">New updates will be available here soon</MDSTypography>
      </div>
    );

  return (
    <div className={classes.wrapper}>
      {isLoading ? (
        <div className={classes.section}>
          <div className={classes.title}>
            <MDSTypography>
              <Skeleton width="80px" />
            </MDSTypography>
          </div>
          <ListItem isLoading />
        </div>
      ) : (
        list.map((item) => (
          <div key={item.date} className={classes.section}>
            <div className={classes.title}>
              <MDSTypography>{item.date}</MDSTypography>
              {item.isNew && (
                <MDSTag size="small" variant="fill" color="red">
                  New
                </MDSTag>
              )}
            </div>
            {item.list.map((popup, index) => (
              <ListItem key={index} data={popup} onClick={onClick} {...listItemProps} />
            ))}
          </div>
        ))
      )}
    </div>
  );
};
